import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import WebtopWindowContext from "../../../webtop/windowManager/WebtopWindowContext";
import { LEAD_LIST_CONTEXT, getLeadListKey, selectLeadList } from "../../../Slices/leadListUtils";

/**
 * Identifies the lead list owned by the window this component renders in.
 * Each webtop window gets its own list, so two Leads windows filter/search/page
 * independently. Outside a webtop window the key is the plain context (legacy).
 */
export const useLeadListKey = () => {
  const { windowId } = useContext(WebtopWindowContext);
  const location = useLocation();
  const isPipeline = location.pathname.toLowerCase().startsWith("/pipeline");
  const context = isPipeline ? LEAD_LIST_CONTEXT.PIPELINE : LEAD_LIST_CONTEXT.SALES;
  return { context, isPipeline, listKey: getLeadListKey(context, windowId) };
};

/** Subscribes to one field of a window's lead list. */
export const useLeadListField = (listKey, field) =>
  useSelector((state) => selectLeadList(state.sales, listKey)[field]);

/** My/All scope of a list; before the list exists, the saved default for its context. */
export const useLeadListScope = (listKey, context) =>
  useSelector((state) =>
    state.sales.leadLists[listKey]?.leadScope || state.sales.leadScope[context] || "MY"
  );
